// extracted by mini-css-extract-plugin
export default {"container":"lq-z","brandName":"mq-z","productName":"nq-z","productNamePdpEnhancements":"oq-z","breakLongProductName":"pq-z"};